import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import path from '../../helpers/path';
import QuickLinkCardArt from './QuickLinkCardArt';
import './DashboardQuickLinks.css';

const base = getBEMClasses('dashboard-quick-links');

const PHOTO_DASHBOARD = path('/local/landing-page/images/dashboard.png');
const PHOTO_TRADE = path(
  '/local/landing-page/images/login-modalbackground.png'
);
const PHOTO_WALLETS = path('/local/landing-page/images/wallet.png');

const buildDefaultLinks = t => [
  {
    path: '/dashboard',
    key: 'dashboard',
    label: 'Dashboard',
    exact: true,
    desc: t('Return to your snapshot, sparklines, and at-a-glance markets.'),
    photo: PHOTO_DASHBOARD
  },
  {
    path: '/trade',
    key: 'trade',
    label: 'Trade',
    desc: t('Charts, order book, and full trading tools for active users.'),
    photo: PHOTO_TRADE
  },
  {
    path: '/wallets',
    key: 'wallets',
    label: 'Wallets',
    desc: t('Holdings, send and receive, and per-product wallet detail.'),
    photo: PHOTO_WALLETS
  }
];

const DashboardQuickLinks = ({ t, links }) => {
  const items = links || buildDefaultLinks(t);

  return (
    <section className={base()}>
      <h2 className={base('section-title')}>{t('Quick links')}</h2>
      <ul className={base('grid')}>
        {items.map(item => (
          <li key={item.key} className={base('cell')}>
            <NavLink
              className={base('card', {
                [item.key]: true,
                withCover: item.photo !== false
              })}
              activeClassName={base('card', {
                [item.key]: true,
                withCover: item.photo !== false,
                active: true
              })}
              to={item.path}
              exact={Boolean(item.exact)}
            >
              {item.photo === false ? null : (
                <div
                  className={base('photo', { [item.key]: true })}
                  style={{
                    backgroundImage: `url(${item.photo || PHOTO_DASHBOARD})`
                  }}
                  aria-hidden
                />
              )}
              <div
                className={base('image', { cover: item.photo !== false })}
              >
                <div className={base('mood')} aria-hidden />
                <div className={base('frost')} aria-hidden />
                <div
                  className={base('glow-orb', { [item.key]: true })}
                  aria-hidden
                />
                {item.photo === false && item.art ? (
                  <div className={base('illustration')}>
                    <QuickLinkCardArt variant={item.art} idPrefix={item.key} />
                  </div>
                ) : null}
              </div>
              <div className={base('text')}>
                <h3 className={base('headline')}>{t(item.label)}</h3>
                {item.desc ? <p className={base('lede')}>{item.desc}</p> : null}
              </div>
            </NavLink>
          </li>
        ))}
      </ul>
    </section>
  );
};

DashboardQuickLinks.defaultProps = {
  links: null
};

DashboardQuickLinks.propTypes = {
  t: PropTypes.func.isRequired,
  links: PropTypes.array
};

export default DashboardQuickLinks;
